import { Controller } from 'react-hook-form';
import { TextAreaProps } from 'semantic-ui-react';
import styled from 'styled-components';

import { TextAreaWithIcon } from 'app/theme/TextAreaWithIcon';
import { breakpoint } from 'app/theme/theme';

interface TextAreaWithIconProps extends Omit<TextAreaProps, 'value'> {
  resize?: string;
}

const StyledTextAreaContainer = styled.div<{ $isValue?: boolean }>`
  display: flex;
  ${breakpoint.up.md`
    font-size: 1.8rem;
  `};
`;

const Icon = styled.div<{ $isValue?: boolean }>`
  position: absolute;
  left: 2.5rem;
  top: 2.2rem;
  color: ${({ theme, $isValue }) => ($isValue ? theme.palette.black : theme.palette.gray.dustyGray)};
  ${breakpoint.up.md`
    left: 3rem; 
  `};
`;

export const TextAreaWithIconAndValidation = ({
  name,
  placeholder,
  rules,
  rows,
  resize,
  textAreaIcon,
}: TextAreaWithIconProps) => (
  <Controller
    rules={rules}
    name={name}
    render={({ ref, value, ...props }) => (
      <>
        <Icon $isValue={Boolean(value)}>{textAreaIcon}</Icon>
        <StyledTextAreaContainer>
          <TextAreaWithIcon {...props} placeholder={placeholder} rows={rows} resize={resize} />
        </StyledTextAreaContainer>
      </>
    )}
  />
);
